<template>
  <div class="container page">
    <AppToolbar
      :title="item ? item.firstName + ' ' + item.lastName : ''"
      :prev-route="item ? { name: 'OrganizationList' } : null"
    >
      <template slot="buttons"> </template>
    </AppToolbar>

    <div v-if="error" class="fill-height">
      <PageNotFound v-if="error === 'Not Found'" />
      <GenericError v-else />
    </div>
    <template v-else>
      <div v-if="isLoading || uploadingImage" class="dialog-spinner">
        <v-progress-circular indeterminate size="50" color="primary"></v-progress-circular>
      </div>
      <template v-else-if="item">
        <v-row>
          <div class="text-center" :class="{ 'mr-3': $vuetify.breakpoint.lgAndUp }">
            <croppa
              v-model="myCroppa"
              :initial-image="item.image ? item.image.contentUrl + '?x-request=html' : null"
              :width="256"
              :height="256"
              :quality="2"
              :accept="'image/*'"
              @file-choose="imageChanged = true"
              @image-remove="imageChanged = true"
            ></croppa>
          </div>

          <v-col>
            <table class="table-alt">
              <tbody>
                <tr>
                  <td class="text-uppercase"><strong>Username</strong></td>
                  <td>{{ item['username'] }}</td>
                </tr>
                <tr>
                  <td class="text-uppercase"><strong>Email</strong></td>
                  <td>{{ item['email'] }}</td>
                </tr>
                <!--
              <tr>
                <td class="text-uppercase">Email Verified</td>
                <td>{{ item['emailVerified'] }}</td>
              </tr>
              <tr>
                <td class="text-uppercase">Enabled</td>
                <td>{{ item['enabled'] }}</td>
              </tr>

              <tr>
                <td>roleInVessels</td>
                <td>{{ item['roleInVessels'] }}</td>
              </tr>
              <tr>
                <td>roleInOrganizations</td>
                <td>{{ item['roleInOrganizations'] }}</td>
              </tr>
              --></tbody>
            </table>
          </v-col>
        </v-row>
        <v-btn v-if="imageChanged" color="warning" fab fixed bottom right @click="submitImage(item)">
          <v-icon>mdi-content-save</v-icon>
        </v-btn>
      </template>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import GenericError from '@/components/error/GenericError'
import PageNotFound from '@/components/error/PageNotFound'
import AppToolbar from '@/components/AppToolbar'
import fetch from '@/utils/fetch'

export default {
  components: {
    GenericError,
    PageNotFound,
    AppToolbar
  },

  data() {
    return {
      uploadingImage: false,
      myCroppa: {},
      imageChanged: false
    }
  },

  computed: {
    ...mapGetters({
      item: 'user/update/retrieved',
      updated: 'user/update/updated',
      isLoading: 'user/update/isLoading',
      error: 'user/update/error'
    })
  },

  watch: {
    updated: function(updated) {
      if (!updated) {
        return
      }

      this.imageChanged = false
    }
  },

  beforeDestroy() {
    this.reset()
  },

  created() {
    this.retrieve('/users/' + this.$route.params.id)
  },

  methods: {
    ...mapActions({
      reset: 'user/update/reset',
      retrieve: 'user/update/retrieve',
      update: 'user/update/update',
      getRoleInVesselsPage: 'roleinvessel/list/default',
      getRoleInOrganizationsPage: 'roleinorganization/list/default'
    }),

    submitImage(item) {
      if (this.imageChanged) {
        this.myCroppa.generateBlob(
          blob => {
            if (blob) {
              let formData = new FormData()
              formData.append('file', blob)

              this.uploadingImage = true

              return fetch('/media_objects', { method: 'POST', body: formData })
                .then(response => {
                  this.uploadingImage = false
                  return response.json()
                })
                .then(data => {
                  item.image = data
                  this.update()
                })
                .catch(e => {
                  // eslint-disable-next-line no-console
                  console.log(e)
                })
            } else {
              item.image = null
              this.update()
            }
          },
          null,
          0.8
        )
      }
    }
  }
}
</script>
